import { ContentManagerModule } from '@2sic.com/sxc-angular';
import { Component, computed, inject, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { Categories, Components, FileData } from '../downloadsModel';
import { ToolbarHelperService } from '../toolbar-helper.service';

@Component({
  selector: 'app-components',
  imports: [MatExpansionModule, ContentManagerModule],
  templateUrl: './components.component.html',
  styleUrl: './components.component.scss',
})
export class ComponentsComponent {

  toolbarHelperSvc = inject(ToolbarHelperService);

  components = input.required<Components[]>();
  categoryInfo = input.required<Categories>();

  sortedComponents = computed(() => {
    return [...this.components()].sort((a, b) => {
      if (a.IsComponents !== b.IsComponents) return a.IsComponents ? 1 : -1;
      const aSN = parseInt(a.SN || '', 10);
      const bSN = parseInt(b.SN || '', 10);

      if (isNaN(aSN)) return 1;
      if (isNaN(bSN)) return -1;

      return aSN - bSN;
    });
  });

  // Helper function to group files by product
  groupFilesByProduct(files: FileData[]): { product: string | null; downloads: FileData[] }[] {
    const grouped: Record<string, FileData[]> = {};
    for (const f of files) {
      const key = f.Product || ''; // empty product → store as ""
      (grouped[key] ??= []).push(f); // sort into the correct group
    }
    return Object.entries(grouped).map(([product, downloads]) => ({
      product: product || null, // "" back to null
      downloads,
    }));
  }

}
